var _circle, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 53,
    viewBox: "0 0 72 53",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2969_41201",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 9,
    y: -1,
    width: 54,
    height: 55
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 36.0001,
    cy: 26.5,
    r: 26.8082,
    fill: "#00406A"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2969_41201)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M58.5831 25.4131C58.6044 17.8018 53.2557 8.51156 46.6358 4.66327C43.5497 2.86971 40.7301 2.57656 38.5981 3.54396H38.5927C38.2463 3.7012 37.9185 3.89574 37.612 4.1196L26.6055 10.5796L42.2438 44.516L54.7295 37.2458L57.5944 30.2875C57.7249 30.013 57.8449 29.7251 57.9515 29.4213L57.9754 29.3627C58.3645 28.2327 58.5831 26.9109 58.5857 25.4078L58.5831 25.4131Z",
    fill: "url(#paint0_linear_2969_41201)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.4525 36.6142C45.8416 35.4843 46.0601 34.1624 46.0628 32.6594C46.0841 25.0481 40.7354 15.7578 34.1155 11.9095C27.4956 8.06119 22.1096 11.1126 22.0882 18.724C22.0829 20.227 22.2908 21.7941 22.6745 23.3718H22.6719L22.7092 23.5077C22.7785 23.7875 22.8531 24.0647 22.933 24.3445L25.7713 34.9406L42.2092 44.4947L45.0741 37.5363C45.2046 37.2619 45.3246 36.974 45.4312 36.6702L45.4552 36.6116L45.4525 36.6142Z",
    fill: "url(#paint1_linear_2969_41201)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.9701 33.051C40.27 31.7183 40.2633 27.4086 37.9551 23.4251C35.6468 19.4416 31.9111 17.2927 29.6112 18.6254C27.3113 19.9581 27.318 24.2677 29.6262 28.2512C31.9344 32.2347 35.6701 34.3837 37.9701 33.051Z",
    fill: "#00406A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.332 36.4515C36.1674 36.4515 34.8855 36.0624 33.561 35.2949C29.0838 32.6938 25.454 26.383 25.4673 21.2315C25.4753 18.6571 26.3708 16.7276 27.9911 15.7976C29.6221 14.8621 31.7621 15.0673 34.014 16.3759C38.4913 18.9769 42.121 25.285 42.1077 30.4392C42.0997 33.0136 41.2043 34.9431 39.5839 35.8732C38.9097 36.2596 38.1502 36.4515 37.332 36.4515ZM30.2484 16.0214C29.5661 16.0214 28.9398 16.1786 28.3909 16.4931C27.029 17.274 26.2748 18.9583 26.2695 21.2342C26.2562 26.1325 29.7074 32.1288 33.9634 34.6046C35.9595 35.7639 37.8144 35.9691 39.1869 35.1803C40.5487 34.3994 41.3029 32.7151 41.3109 30.4392C41.3242 25.5409 37.873 19.5446 33.617 17.0688C32.4204 16.3732 31.2744 16.0214 30.251 16.0214H30.2484Z",
    fill: "#00406A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.3584 31.0356V30.1614L25.3344 29.1807C25.3238 28.7783 25.2198 28.5304 24.9906 28.4212C24.6682 28.2693 24.3697 28.4771 24.1938 28.5651C23.882 28.7357 13.6563 34.5507 12.8195 35.0811C11.94 35.6407 12.012 36.1684 12.0146 36.4642V37.357C12.0146 37.357 12.0146 38.3404 12.0146 38.3484C12.0146 38.487 12.1266 38.6042 12.2652 38.6042C12.4037 38.6042 12.5157 38.4923 12.5157 38.3537V37.381V36.4402C12.5103 36.4216 12.4677 35.8753 13.0886 35.5048C13.9415 34.9931 24.4097 29.0181 24.447 28.9968L24.4816 28.9755C24.5989 28.9062 24.7215 28.8449 24.7801 28.8849C24.8307 28.9169 24.8254 28.9489 24.8307 29.194L24.8547 30.1668V31.0409V31.0356C24.8547 31.0356 24.8547 31.0436 24.8547 31.0462C24.8547 31.1848 24.9667 31.2967 25.1052 31.2967C25.2438 31.2967 25.3557 31.1848 25.3557 31.0462C25.3557 31.0462 25.3557 31.0382 25.3557 31.0356H25.3584Z",
    fill: "#FDFFF8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.7633 43.2523L25.2754 33.1065L25.7684 34.9427L42.2436 44.5181L42.7633 43.2523Z",
    fill: "#00406A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.8677 19.0479C33.4306 18.7948 33.0042 18.6029 32.5965 18.4696C32.0795 19.0959 31.7757 20.0233 31.773 21.2039C31.7623 24.5006 34.0782 28.5194 36.9431 30.1851C37.8919 30.7367 38.6701 31.1445 39.4376 31.0752C39.5682 30.5928 39.7494 29.8653 39.7521 29.263C39.7627 25.5133 37.1297 20.9401 33.873 19.0453L33.8677 19.0479Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.7636 43.2525L55.2732 35.929L54.7269 37.2482L42.2439 44.5184L42.7636 43.2525Z",
    fill: "#00406A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.5272 23.0409V15.7388C49.5272 14.83 49.0449 13.9905 48.2613 13.5321L40.0664 8.74308V9.953C44.2318 12.8739 47.7523 17.8761 49.5272 23.0409Z",
    fill: "#8F9180"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.3077 9.36414L47.6058 4.86292C47.3019 4.68436 46.9262 4.68703 46.6224 4.86558L40.0664 8.75119L48.2614 13.5402C49.0449 13.9986 49.5272 14.8381 49.5272 15.7469V23.049L56.0086 19.2087C56.3577 19.0009 56.5736 18.6251 56.5736 18.2173V11.5708C56.5736 10.662 56.0912 9.82252 55.3077 9.36414Z",
    fill: "url(#paint2_linear_2969_41201)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.4593 34.0772L26.3045 33.8853L14.7756 42.0776L9.60547 47.6741L12.0413 52.1966L34.0384 39.5271C34.121 39.5085 34.193 39.4658 34.2516 39.4045L34.2649 39.3965V39.3912C34.3742 39.266 34.4435 39.0714 34.4435 38.8129L34.9338 33.3763L30.4593 34.0745V34.0772Z",
    fill: "url(#paint3_linear_2969_41201)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.1428 33.5523V32.8781L29.702 36.6864L23.2393 32.8941C22.9115 32.7022 22.4158 32.6782 22.1307 32.8408L7.90746 40.9184L6.25781 41.3209V42.0271H6.26048C6.26048 42.1497 6.35109 42.2829 6.52698 42.3842L13.528 46.4937C13.8558 46.6855 14.3515 46.7095 14.6366 46.547L36.9509 33.8695C37.0975 33.7868 37.1588 33.6669 37.1401 33.547L37.1428 33.5523Z",
    fill: "url(#paint4_linear_2969_41201)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.9482 33.0586L14.6366 45.792C14.3515 45.9546 13.8558 45.9306 13.528 45.7387L6.52696 41.6293C6.19916 41.4374 6.16718 41.1496 6.45234 40.987L28.7639 28.2535C29.0491 28.091 29.5448 28.1149 29.8726 28.3068L36.8736 32.4163C37.2014 32.6082 37.2334 32.896 36.9482 33.0586Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.2093 36.1554V35.2813L33.1853 34.3005C33.1746 33.8981 33.0707 33.6503 32.8415 33.541C32.519 33.3891 32.2205 33.597 32.0446 33.6849C31.7328 33.8555 21.5071 39.6705 20.673 40.2009C19.7935 40.7605 19.8655 41.2882 19.8682 41.584V42.4768C19.8682 42.4768 19.8682 43.4602 19.8682 43.4682C19.8682 43.6068 19.9801 43.724 20.1187 43.724C20.2572 43.724 20.3692 43.6121 20.3692 43.4735V42.5008V41.56C20.3639 41.5414 20.3212 40.9951 20.9422 40.6246C21.795 40.1129 32.2632 34.138 32.3005 34.1166L32.3351 34.0953C32.4524 34.026 32.575 33.9647 32.6336 34.0047C32.6843 34.0367 32.6789 34.0687 32.6843 34.3139L32.7082 35.2866V36.1607V36.1554C32.7082 36.1554 32.7082 36.1634 32.7082 36.166C32.7082 36.3046 32.8202 36.4166 32.9587 36.4166C33.0973 36.4166 33.2093 36.3046 33.2093 36.166C33.2093 36.166 33.2093 36.158 33.2093 36.1554Z",
    fill: "#FDFFF8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.6639 30.2324L39.4347 31.0772L37.3587 32.4524C37.2281 32.5403 37.0575 32.543 36.9216 32.4604L36.3459 32.1086L36.6311 30.5069L39.6639 30.2324Z",
    fill: "url(#paint5_linear_2969_41201)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.9843 28.9734L36.1464 32.0008C36.3836 32.1394 36.6767 32.1394 36.9166 32.0008L39.6642 30.2286C39.7389 29.8422 39.7469 29.613 39.7469 29.1572C39.7522 27.6249 39.2139 25.8526 38.473 24.2856L30.9923 28.4697C30.795 28.5763 30.7897 28.8561 30.9843 28.9707V28.9734Z",
    fill: "#2F7BAC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.2843 14.9257L50.8758 16.8925C50.7345 16.9751 50.6173 16.8871 50.6199 16.6979V16.2289C50.6199 16.0397 50.7345 15.8185 50.8784 15.7385L54.287 13.7717C54.4282 13.6891 54.5455 13.7771 54.5428 13.9663V14.4353C54.5428 14.6245 54.4282 14.8457 54.2843 14.9257Z",
    fill: "#00406A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.4756 14.2381L55.1025 14.454C54.9613 14.5366 54.8467 14.4487 54.8467 14.2595V13.7904C54.8467 13.6012 54.9613 13.38 55.1052 13.3001L55.4783 13.0842C55.6195 13.0016 55.7368 13.0895 55.7341 13.2787V13.7478C55.7341 13.937 55.6195 14.1582 55.4756 14.2381Z",
    fill: "#00406A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.6035 17.7612L50.8731 20.5035C50.7318 20.5861 50.6146 20.4982 50.6172 20.309V17.9984C50.6172 17.8092 50.7345 17.588 50.8757 17.508L55.6062 14.7657C55.7474 14.6831 55.8647 14.7711 55.862 14.9603V17.2708C55.862 17.4601 55.7447 17.6813 55.6035 17.7612Z",
    fill: "#00406A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.4991 9.38098L45.487 10.5429C45.2259 10.6948 44.7675 10.6762 44.4637 10.5003L43.2671 9.81005C42.9633 9.63416 42.8247 8.89328 43.0859 8.74138L45.2046 8.05647C45.4657 7.90456 45.9241 7.92321 46.2279 8.09911L47.5338 8.29898C47.8376 8.47487 47.7603 9.22641 47.4991 9.37832V9.38098Z",
    fill: "url(#paint6_linear_2969_41201)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.4992 8.81244L45.4871 9.9744C45.226 10.1263 44.7676 10.1076 44.4638 9.93175L43.2672 9.24151C42.9634 9.06562 42.9314 8.80178 43.1926 8.65254L45.2046 7.49059C45.4658 7.33869 45.9242 7.35734 46.228 7.53323L47.4246 8.22348C47.7284 8.39937 47.7604 8.6632 47.4992 8.81244Z",
    fill: "url(#paint7_linear_2969_41201)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.919 27.7103C49.8231 26.7589 49.6525 25.7888 49.4153 24.8188C49.3514 24.5523 49.0449 24.4244 48.8051 24.5603L46.9689 25.605C46.809 25.6956 46.729 25.8795 46.769 26.058C46.8383 26.3592 46.9502 26.8522 47.0408 27.3719C47.1447 27.9688 47.206 28.4485 47.2407 28.7977C47.27 29.0935 47.5898 29.2587 47.851 29.1175L49.7005 28.1154C49.8471 28.0355 49.935 27.8756 49.919 27.7077V27.7103Z",
    fill: "url(#paint8_linear_2969_41201)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.3642 37.1713C50.1297 37.1713 49.8712 37.0887 49.5887 36.9235C48.0643 36.028 48.5653 28.2488 48.6266 27.364L48.8931 27.3827C48.7279 29.7386 48.5546 36.0067 49.7246 36.6943C50.1137 36.9235 50.4255 36.9661 50.6733 36.8275C51.67 36.2705 51.7393 32.8966 51.8193 28.9924C51.8273 28.5793 51.8353 28.1555 51.8459 27.7291C51.9765 22.0526 51.8939 18.6627 51.8912 18.6307L52.1577 18.6228C52.1577 18.6467 52.2484 20.944 53.1385 21.4903C53.3863 21.6422 53.6715 21.6396 54.0099 21.4823C55.8062 20.6482 55.1666 16.9864 55.1586 16.9491L55.4197 16.9011C55.449 17.061 56.102 20.8001 54.1219 21.7222C53.7008 21.9194 53.3224 21.9167 52.9972 21.7168C52.6001 21.4717 52.3443 20.96 52.1817 20.4216C52.1924 21.9727 52.1871 24.4805 52.1124 27.7345C52.1018 28.1635 52.0938 28.5846 52.0858 28.9977C52.0005 33.1498 51.9339 36.4278 50.8012 37.0594C50.668 37.134 50.5214 37.1713 50.3642 37.1713Z",
    fill: "#F3FFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.211 19.0802L51.8379 19.296C51.6967 19.3787 51.5794 19.2907 51.5821 19.1015V18.6325C51.5821 18.4432 51.6967 18.222 51.8406 18.1421L52.2137 17.9262C52.3549 17.8436 52.4722 17.9316 52.4695 18.1208V18.5898C52.4695 18.779 52.3549 19.0002 52.211 19.0802Z",
    fill: "url(#paint9_linear_2969_41201)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.4553 27.4624C49.4073 26.98 49.3221 26.487 49.1995 25.9939C49.1675 25.858 49.0102 25.7941 48.8903 25.8633L47.9576 26.3937C47.8776 26.439 47.835 26.5323 47.8563 26.6229C47.8909 26.7748 47.9469 27.0253 47.9949 27.2891C48.0482 27.5903 48.0775 27.8355 48.0961 28.0114C48.1121 28.1606 48.2747 28.2459 48.4053 28.1739L49.3434 27.6649C49.418 27.6249 49.4633 27.5423 49.4526 27.4597L49.4553 27.4624Z",
    fill: "url(#paint10_linear_2969_41201)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.4756 17.1943L55.1025 17.4102C54.9613 17.4928 54.8467 17.4049 54.8467 17.2156V16.7466C54.8467 16.5574 54.9613 16.3362 55.1052 16.2562L55.4783 16.0404C55.6195 15.9578 55.7368 16.0457 55.7341 16.2349V16.704C55.7341 16.8932 55.6195 17.1144 55.4756 17.1943Z",
    fill: "url(#paint11_linear_2969_41201)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.5827 15.7849L23.4765 14.5856C23.5671 14.5723 23.6497 14.5963 23.719 14.6469C23.7483 14.6682 23.7723 14.6949 23.7936 14.7242L24.316 15.2545L23.8949 15.633L23.9002 20.414C23.9002 20.7045 23.7137 20.9684 23.4818 21.003L16.8059 22.0184L15.9745 22.7672L15.3482 22.1436C15.2416 22.0637 15.1696 21.9198 15.1696 21.7412L15.1616 16.3765C15.1616 16.086 15.3482 15.8222 15.58 15.7876L15.5827 15.7849Z",
    fill: "url(#paint12_linear_2969_41201)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.193 22.8132L24.0868 21.6139C24.3186 21.5793 24.5052 21.3154 24.5052 21.025L24.4972 15.6603C24.4972 15.3698 24.308 15.1646 24.0761 15.1992L16.1823 16.3985C15.9505 16.4331 15.7639 16.697 15.7639 16.9874L15.7719 22.3521C15.7719 22.6426 15.9611 22.8478 16.193 22.8132Z",
    fill: "#F9F9EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.7875 22.0529L23.6713 21.0082C23.7992 20.9895 23.9058 20.8429 23.9031 20.6804L23.8978 16.2831C23.8978 16.1205 23.7939 16.0059 23.6633 16.0273L16.7795 17.0719C16.6516 17.0906 16.545 17.2372 16.5477 17.3997L16.553 21.797C16.553 21.9596 16.6569 22.0742 16.7875 22.0529Z",
    fill: "#2E3535"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.583 23.3667L23.4768 22.1674C23.5674 22.1541 23.65 22.1781 23.7193 22.2287C23.7486 22.25 23.7726 22.2767 23.7939 22.306L24.3162 22.8363L23.8952 23.2148V23.2334C23.8952 23.5239 23.7086 23.7877 23.4768 23.8224L16.8009 24.8378L15.9694 25.5866L15.3431 24.963C15.2365 24.8831 15.1646 24.7392 15.1646 24.5606V23.9583C15.1646 23.6678 15.3511 23.404 15.583 23.3693V23.3667Z",
    fill: "url(#paint13_linear_2969_41201)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.1877 25.6292L24.0815 24.43C24.3133 24.3953 24.4999 24.1315 24.4999 23.841V23.2387C24.4999 22.9482 24.3107 22.743 24.0788 22.7776L16.185 23.9769C15.9532 24.0116 15.7666 24.2754 15.7666 24.5659V25.1682C15.7666 25.4587 15.9558 25.6639 16.1877 25.6292Z",
    fill: "#F9F9EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.7848 25.0566L22.7465 24.1398C22.8744 24.1212 22.981 23.9746 22.9784 23.812V23.7427C22.9757 23.5802 22.8718 23.4656 22.7412 23.4869L16.7795 24.4036C16.6516 24.4223 16.545 24.5689 16.5477 24.7314V24.8007C16.5503 24.9633 16.6543 25.0779 16.7848 25.0566Z",
    fill: "#2773E2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.4792 24.0096L23.6711 23.9803C23.799 23.9616 23.9056 23.815 23.9029 23.6525V23.5832C23.9003 23.4206 23.7963 23.306 23.6657 23.3273L23.4738 23.3567C23.3459 23.3753 23.2393 23.5219 23.242 23.6844V23.7537C23.2447 23.9163 23.3486 24.0309 23.4792 24.0096Z",
    fill: "#FF3222"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.0799 22.5245V23.873H17.6189V22.3939L18.0799 22.5245Z",
    fill: "#F9F9EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.8397 21.7865V23.135H22.3787V21.6559L22.8397 21.7865Z",
    fill: "#F9F9EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.619 22.5965L17.0327 22.6844V23.1455L17.619 23.7584V22.5965Z",
    fill: "url(#paint14_linear_2969_41201)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.3785 21.8688L21.7922 21.9567V22.4178L22.3785 23.0307V21.8688Z",
    fill: "url(#paint15_linear_2969_41201)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.0621 45.1949V43.969C17.0621 43.4387 16.7369 42.8231 16.3398 42.5939L8.69122 38.1886C8.55264 38.1086 8.42472 38.09 8.31545 38.1166H8.31012C8.25149 38.1326 8.19819 38.1646 8.15289 38.2072L5.94092 39.4784L10.2289 43.3347L10.602 49.0192L9.20291 48.7847L10.2289 51.1619L11.6494 52.9102L14.1412 51.5323L14.2318 51.3458C14.2691 51.2952 14.2984 51.2285 14.3224 51.1592L14.3304 51.1459C14.3597 51.0446 14.381 50.9327 14.381 50.8048L14.7115 47.0684L16.8169 45.7812H16.8142C16.9661 45.6906 17.0647 45.4907 17.0647 45.2003L17.0621 45.1949Z",
    fill: "url(#paint16_linear_2969_41201)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.053 43.9721L6.40437 39.5668C6.00728 39.3376 5.68481 39.5828 5.68481 40.1132V41.3391C5.68481 41.8694 6.00995 42.485 6.40704 42.7142L7.8648 43.5537L8.34717 50.0244C8.34717 50.6373 8.72294 51.3516 9.18132 51.6154L11.2574 52.812C11.7184 53.0785 12.0915 52.796 12.0915 52.1804L12.5632 46.2587L14.0557 47.1195C14.4527 47.3487 14.7752 47.1035 14.7752 46.5732V45.3473C14.7752 44.8169 14.4501 44.2013 14.053 43.9721Z",
    fill: "url(#paint17_linear_2969_41201)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.4951 41.0072L40.4744 40.4022C40.2639 40.2769 40.096 39.9438 40.0933 39.656V38.2542C40.0906 37.9664 40.2585 37.8331 40.4691 37.9584L41.4898 38.5633C41.7003 38.6886 41.8682 39.0217 41.8709 39.3095V40.7113C41.8735 40.9992 41.7056 41.1324 41.4951 41.0072Z",
    fill: "url(#paint18_linear_2969_41201)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.0072 38.6623C41.0072 38.6623 41.0254 38.6778 41.0332 38.6856C41.041 38.6882 41.0461 38.6856 41.0539 38.6934L41.0046 38.6623H41.0072Z",
    fill: "url(#paint19_linear_2969_41201)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.2606 40.08V39.1526C41.2606 38.9767 41.1593 38.7768 41.034 38.6835C40.9861 38.6622 40.9434 38.6595 40.9061 38.6782V38.6729L40.8875 38.6835C40.8848 38.6835 40.8795 38.6862 40.8768 38.6915L40.1919 39.1259L40.4397 40.7596L41.146 40.3065V40.2959C41.2126 40.2745 41.2606 40.2026 41.2606 40.08Z",
    fill: "url(#paint20_linear_2969_41201)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.2958 40.7265L40.3465 40.7585C40.2079 40.6759 40.0959 40.4547 40.0959 40.2655V39.338C40.0959 39.1488 40.2052 39.0609 40.3438 39.1435L40.2932 39.1115C40.4317 39.1941 40.5437 39.4153 40.5437 39.6045V40.532C40.5437 40.7212 40.4344 40.8091 40.2958 40.7265Z",
    fill: "url(#paint21_linear_2969_41201)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.8752 44.5934H12.8406C12.7899 44.5934 12.7446 44.6067 12.7047 44.628V44.6227L11.2202 45.5102L11.1749 45.5421C11.1749 45.5421 10.9884 45.6807 10.3648 45.7847C9.74382 45.8859 9.02693 45.6114 8.91234 45.5635L5.34387 43.4528C4.54437 42.9784 4.11263 42.6772 3.87811 42.488C4.10464 42.528 4.36581 42.5973 4.48307 42.6506C5.50111 43.1063 5.94883 42.9251 6.07942 42.8398L7.61714 41.931C7.70508 41.8804 7.76638 41.7871 7.76638 41.6779V41.6699C7.76638 41.51 7.63579 41.3794 7.47589 41.3794H7.44125C7.39594 41.3794 7.35063 41.3927 7.31332 41.4114V41.406L5.76495 42.3201C5.73297 42.3308 5.45047 42.4134 4.73625 42.0936C4.72292 42.0883 3.33444 41.5446 3.05195 42.0936C2.86274 42.456 3.11858 42.8478 5.03473 43.9804L8.62185 46.1045L8.6565 46.1231C8.68848 46.1364 9.35473 46.4216 10.077 46.4216C10.2075 46.4216 10.3381 46.4136 10.466 46.3896C11.159 46.275 11.4494 46.1071 11.556 46.0218L13.0165 45.1477C13.1071 45.0971 13.171 45.0011 13.171 44.8919V44.8839C13.171 44.724 13.0405 44.5934 12.8806 44.5934H12.8752Z",
    fill: "#FDFFF8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.22352 42.4046C6.18355 42.386 6.13824 42.3727 6.09027 42.3727H6.05562C5.89572 42.3727 5.76514 42.5032 5.76514 42.6631V42.6711C5.76514 42.7831 5.8291 42.879 5.92237 42.927L11.2311 46.0344L11.5402 45.5067L6.23152 42.4046H6.22352Z",
    fill: "#FDFFF8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.3267 31.8924L35.2986 33.065C35.0348 33.217 34.5738 33.1983 34.2673 33.0224L33.0627 32.3268C32.7589 32.1509 32.7242 31.8844 32.9881 31.7325L35.0162 30.5599C35.28 30.408 35.741 30.4267 36.0475 30.6026L37.2521 31.2981C37.5559 31.474 37.5906 31.7405 37.3267 31.8924Z",
    fill: "url(#paint22_linear_2969_41201)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.3267 31.3231L35.2986 32.4957C35.0348 32.6476 34.5738 32.629 34.2673 32.4531L33.0627 31.7575C32.7589 31.5816 32.7242 31.3151 32.9881 31.1632L35.0162 29.9906C35.28 29.8387 35.741 29.8574 36.0475 30.0333L37.2521 30.7288C37.5559 30.9047 37.5906 31.1712 37.3267 31.3231Z",
    fill: "#F7EAE8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.1999 51.604C31.1999 52.2089 30.2832 52.6993 29.1532 52.6993C28.0232 52.6993 27.1064 52.2089 27.1064 51.604C27.1064 51.3481 27.2957 50.4953 27.5702 50.3088C27.9459 50.0529 28.5029 50.5087 29.1558 50.5087C29.8088 50.5087 30.3951 50.0743 30.7682 50.3434C31.0187 50.5247 31.2026 51.3588 31.2026 51.6013L31.1999 51.604Z",
    fill: "url(#paint23_linear_2969_41201)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.1531 51.8307C30.1863 51.8307 31.0239 51.3833 31.0239 50.8313C31.0239 50.2794 30.1863 49.832 29.1531 49.832C28.1198 49.832 27.2822 50.2794 27.2822 50.8313C27.2822 51.3833 28.1198 51.8307 29.1531 51.8307Z",
    fill: "url(#paint24_linear_2969_41201)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.1532 50.9617C28.8973 50.9617 28.6921 50.7539 28.6921 50.5007V45.3092C28.6921 45.0534 28.9 44.8482 29.1532 44.8482C29.409 44.8482 29.6142 45.056 29.6142 45.3092V50.5007C29.6142 50.7565 29.4064 50.9617 29.1532 50.9617Z",
    fill: "#2D363F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.6311 43.7392C32.6311 44.7332 31.1253 45.538 29.2678 45.538C27.4103 45.538 25.9045 44.7332 25.9045 43.7392C25.9045 43.3207 26.2137 41.9189 26.6641 41.6125C27.2797 41.1941 28.1938 41.9403 29.2678 41.9403C30.3418 41.9403 31.3065 41.226 31.9195 41.6684C32.3299 41.9669 32.6337 43.3394 32.6337 43.7365L32.6311 43.7392Z",
    fill: "#00406A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.343 42.4734C32.343 43.3822 30.9652 44.1177 29.2676 44.1177C27.57 44.1177 26.1921 43.3822 26.1921 42.4734C26.1921 41.5646 27.57 40.8291 29.2676 40.8291C30.9652 40.8291 32.343 41.5646 32.343 42.4734Z",
    fill: "url(#paint25_linear_2969_41201)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.2677 43.4428C30.4673 43.4428 31.4397 42.9226 31.4397 42.2809C31.4397 41.6391 30.4673 41.1189 29.2677 41.1189C28.0681 41.1189 27.0957 41.6391 27.0957 42.2809C27.0957 42.9226 28.0681 43.4428 29.2677 43.4428Z",
    fill: "#00406A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2969_41201",
    x1: 41.1192,
    y1: 13.0155,
    x2: 59.6464,
    y2: 52.1353,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#79826A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2969_41201",
    x1: 19.6922,
    y1: -2.04519,
    x2: 41.5917,
    y2: 88.1565,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#79826A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2969_41201",
    x1: 49.2447,
    y1: 11.219,
    x2: 52.5067,
    y2: 16.2745,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E2E1CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#AFAE94"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2969_41201",
    x1: 28.5298,
    y1: 52.7909,
    x2: 22.0005,
    y2: 39.9988,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#79826A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_2969_41201",
    x1: 26.0669,
    y1: 42.123,
    x2: 11.3267,
    y2: 26.5646,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#175672"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1BAACC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_2969_41201",
    x1: 38.5712,
    y1: 31.6475,
    x2: 35.1494,
    y2: 28.7613,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#175672"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1BAACC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_2969_41201",
    x1: 43.6162,
    y1: 4.89308,
    x2: 46.1666,
    y2: 10.9,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE966"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AF2F02"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_2969_41201",
    x1: 39.6001,
    y1: 8.73249,
    x2: 51.2303,
    y2: 8.73249,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE966"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CE8900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_2969_41201",
    x1: 53.1117,
    y1: 35.199,
    x2: 47.7497,
    y2: 25.8102,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#79826A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_2969_41201",
    x1: 51.0251,
    y1: 18.6111,
    x2: 54.8307,
    y2: 18.6111,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#79826A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_2969_41201",
    x1: 49.2101,
    y1: 27.998,
    x2: 46.4891,
    y2: 23.2356,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#79826A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_2969_41201",
    x1: 54.2897,
    y1: 16.7226,
    x2: 58.0953,
    y2: 16.7226,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#79826A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_2969_41201",
    x1: 39.944,
    y1: 15.0906,
    x2: 4.30836,
    y2: 26.3262,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#79826A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_2969_41201",
    x1: 33.0077,
    y1: 19.8965,
    x2: 4.62598,
    y2: 28.8443,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#79826A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_2969_41201",
    x1: 16.1213,
    y1: 21.1014,
    x2: 17.5231,
    y2: 23.1588,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#79826A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_2969_41201",
    x1: 20.8808,
    y1: 20.3764,
    x2: 22.2826,
    y2: 22.4311,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#79826A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_2969_41201",
    x1: 11.1111,
    y1: 42.6871,
    x2: 19.0875,
    y2: 57.3927,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#79826A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_2969_41201",
    x1: -7.95477,
    y1: 24.2536,
    x2: 23.8896,
    y2: 62.566,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#79826A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_2969_41201",
    x1: 41.6692,
    y1: 41.3776,
    x2: 37.6297,
    y2: 26.5674,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#79826A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_2969_41201",
    x1: 40.9669,
    y1: 38.6571,
    x2: 40.984,
    y2: 38.7003,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EFE1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B28A7F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_2969_41201",
    x1: 40.1529,
    y1: 38.9447,
    x2: 40.793,
    y2: 40.6023,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#79826A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_2969_41201",
    x1: 40.7142,
    y1: 40.7532,
    x2: 36.6501,
    y2: 32.2917,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#79826A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_2969_41201",
    x1: 34.5391,
    y1: 29.0169,
    x2: 35.4292,
    y2: 33.0411,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EFE1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B28A7F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_2969_41201",
    x1: 29.8194,
    y1: 51.6839,
    x2: 26.4109,
    y2: 49.7891,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0A5975"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1BAACC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_2969_41201",
    x1: 27.9298,
    y1: 49.5575,
    x2: 33.4278,
    y2: 55.2899,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#79826A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_2969_41201",
    x1: 27.2581,
    y1: 40.3787,
    x2: 36.2952,
    y2: 49.7996,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#79826A"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCt);
export default __webpack_public_path__ + "static/media/ct.3f933132f40c244e8d4e16b57eccc822.svg";
export { ForwardRef as ReactComponent };